import React from 'react'

type props = {
  title?: string
}

const SPBreadcrumb: React.FC<props> = (props) => {
  const style: React.CSSProperties = {
    height: '55px',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '55px',
    paddingLeft: '16px',
    margin: '-20px -20px 0 -20px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
  }

  return <div style={style}>{props?.title}</div>
}

export default SPBreadcrumb;
